import React, { lazy } from 'react';
import { CheckIcon, CreditCardIcon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
const items = ['6 complete volumes', '5 strategic bonuses', '200+ ready-to-run sessions', '120+ professional drills & games', 'All age groups', 'Lifetime access'];
export function PricingSection() {
  return <section id="pricing" className="bg-[#f4f8f5] px-5 py-20" data-id="element-140" data-mp="1ja9x95bb50hh">
      <div className="mx-auto max-w-xl text-center" data-id="element-141" data-mp="1n9ioa2eyqk9c">
        <p className="inline-block bg-[#09281d] px-4 py-2 text-xs font-bold uppercase tracking-widest text-white" data-id="element-142" data-mp="1ncwpv8fsypfq">
          Limited-time offer
        </p>
        <h2 className="mt-5 font-display text-4xl font-bold uppercase leading-none text-[#09281d] sm:text-5xl" data-id="element-143" data-mp="1xa1hhnsf3d3x">
          Everything you need to plan your PE year —{' '}
          <span className="text-emerald-700" data-id="element-144" data-mp="2v8kplfssgae">one simple payment.</span>
        </h2>
        <article className="mt-10 overflow-hidden border border-emerald-950/10 bg-white text-center shadow-xl" data-id="element-145" data-mp="7ts6nlue5s2r">
          <header className="border-t-4 border-emerald-500 bg-[#09281d] px-6 py-7" data-id="element-146" data-mp="1mh6k6y6bl04x">
            <h3 className="font-display text-3xl font-bold uppercase text-white" data-id="element-147" data-mp="1hpy6hpxyisly">
              P.E. READY 360 — Complete Package
            </h3>
            <p className="mt-2 text-sm font-semibold text-emerald-300" data-id="element-148" data-mp="1crn0jqas9290">
              6 Volumes + 5 Strategic Bonuses
            </p>
          </header>
          <div className="p-7 sm:p-10" data-id="element-149" data-mp="25fiwgssj2q4q">
            <img src="https://cdn.magicpatterns.com/uploads/6oCaLFtRoMgn6SjBaq7U44/Diseno-sin-titulo-2026-07-14T111227.541.webp" alt="P.E. READY 360 complete teaching package" width={1080} height={728} loading="lazy" className="mx-auto -mt-3 mb-3 w-full max-w-md object-contain" data-id="element-150" data-mp="25e7qqnfiv8az" />
            <div id="offer-details" className="mb-8 scroll-mt-3 border-y border-emerald-950/10 py-7" data-id="element-151" data-mp="k2pk7sq4tfiw">
              <p className="mb-5 text-xs font-bold uppercase tracking-widest text-[#09281d]" data-id="element-152" data-mp="fzb28wimup2t">
                What's included
              </p>
              <ul className="grid gap-3 text-left sm:grid-cols-2" data-id="element-153" data-mp="mgl0486rpsev">
                {items.map(item => <li key={item} className="flex items-center gap-2 text-sm font-semibold text-[#09281d]" data-id="element-154" data-mp="7k3pjj6ekhtd">
                    <span className="grid h-5 w-5 place-items-center rounded-full bg-emerald-100" data-id="element-155" data-mp="ckhx7043dpqv">
                      <CheckIcon className="h-3.5 w-3.5 text-emerald-700" data-id="element-156" data-mp="3uutlowavhixj" />
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="mt-7" data-id="element-157" data-mp="3pxkyuies4qpy">
              <p className="text-sm font-semibold text-slate-600" data-id="element-158" data-mp="3pymmrngw97p3">
                Total value: <s data-id="element-159" data-mp="3bxa77d5nb83q">$90 USD</s>
              </p>
              <div className="mt-1 flex items-baseline justify-center text-[#09281d]" data-id="element-160" data-mp="3bylma94jk2a5">
                <span className="font-display text-5xl font-bold" data-id="element-161" data-mp="3fy3xueah310b">$</span>
                <strong className="font-display text-8xl font-bold leading-none tracking-tight" data-id="element-162" data-mp="2xabivr234tt8">
                  27
                </strong>
                <span className="ml-2 text-sm font-bold text-slate-600" data-id="element-163" data-mp="2sdux33icyrjb">
                  USD
                </span>
              </div>
              <div className="mt-3 flex flex-wrap justify-center gap-3" data-id="element-164" data-mp="31cyd1ym8aqtl">
                <span className="bg-emerald-500 px-3 py-1.5 text-xs font-bold uppercase tracking-widest text-white" data-id="element-165" data-mp="31f1dlcl0c2ck">
                  Save $63
                </span>
                <span className="py-1.5 text-xs font-bold uppercase tracking-widest text-slate-600" data-id="element-166" data-mp="3ba2z7yg2qmae">
                  One-time payment
                </span>
                <span className="py-1.5 text-xs font-bold uppercase tracking-widest text-slate-600" data-id="element-167" data-mp="3l0xm95159pww">
                  Lifetime access
                </span>
              </div>
            </div>
            <a href="https://p-e-ready.impultienda.ar/checkout" className="cta-button -mx-2 mt-6 block w-[calc(100%+1rem)] rounded-2xl px-6 py-6 text-xl font-bold sm:text-2xl" data-id="element-168" data-mp="3u1m64gd7ykhp">
              GET P.E. READY 360 NOW — ONLY $27 USD
            </a>
            <p className="mt-5 flex items-center justify-center gap-1.5 text-xs font-semibold text-slate-600" data-id="element-169" data-mp="qqebujl7jmfp">
              <ShieldCheckIcon className="h-4 w-4 text-emerald-700" data-id="element-170" data-mp="vp7oyawl1bfc" /> Backed by
              our 7-day money-back guarantee
            </p>
            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 border-t border-emerald-950/10 pt-6 text-xs font-bold text-slate-600" data-id="element-171" data-mp="3v5xlljjxa3gu">
              <span className="flex gap-1" data-id="element-172" data-mp="7zwmmozl38z3">
                <LockKeyholeIcon className="h-4 w-4" data-id="element-173" data-mp="7z51k83m4tn2" /> Secure payment
              </span>
              <span className="flex gap-1" data-id="element-174" data-mp="d012ccso3zo9">
                <ZapIcon className="h-4 w-4" data-id="element-175" data-mp="cwn0d5nx1shc" /> Access in 5 min
              </span>
              <span className="flex gap-1" data-id="element-176" data-mp="1jetq33wim0pz">
                <CreditCardIcon className="h-4 w-4" data-id="element-177" data-mp="1odn3kwbsxrq5" /> Card · GooglePay ·
                ApplePay
              </span>
            </div>
          </div>
        </article>
        <p className="mt-5 text-xs font-semibold text-slate-600" data-id="element-178" data-mp="38ya4b0z57q4d">
          Price shown in USD — you’ll be charged the equivalent in your
          country’s local currency.
        </p>
      </div>
    </section>;
}